import { type FavoriteVariables } from '@/hooks/data/useNodeFavorite';
import { type DAMNodeType, type NodeType } from '@/types/tree';
import type { Command } from '@/context/CommandContext';
import { t } from '@/i18n/translator';

export const FavoriteNodeCommand = (
  nodeId: string,
  current: boolean,
  next: boolean,
  nodeType: NodeType | DAMNodeType,
  mutate: (vars: FavoriteVariables) => Promise<unknown>,
): Command => {
  let chain: Promise<unknown> = Promise.resolve(); // serialize for this command instance

  const run = (vars: FavoriteVariables) => {
    chain = chain.then(() => mutate(vars));
    return chain;
  };

  const apply = () => run({ nodeId, next, nodeType }); // toast shown
  const undo = (): void => {
    void run({ nodeId, next: current, nodeType, silent: true });
  }; // no toast
  const redo = (): void => {
    void run({ nodeId, next, nodeType, silent: true });
  }; // no toast

  return {
    apply,
    undo,
    redo,
    message: next ? t('commands.favoriteAdded') : t('commands.favoriteRemoved'),
  };
};
